import {Component, Input} from '@angular/core';
import {Adresse, AdresseListItem} from "@domain/profil/adresse";

/**
 * Composant d'affichage d'un lieu récent
 */
@Component({
    host: {'data-test-id': 'lieux-recents-list-item'},
    templateUrl: './lieux-recents-list-item.component.html'
})
export class LieuxRecentsListItemComponent {

    /** Options supplémentaires */
    @Input() extraOptions: {
        selectAdresse: (adresse: Adresse) => void
    };

    /** Adresse à afficher */
    @Input() data: AdresseListItem;

    /**
     * Sélection de l'adresse à partir de la liste
     *
     * @param adresse Adresse sélectionnée
     */
    selectAdresse(adresse: Adresse) {
        this.extraOptions.selectAdresse(adresse);
    }
}